import { render } from "./Partners.vue?vue&type=template&id=1f7f7a77"
import script from "./Partners.vue?vue&type=script&lang=js"
export * from "./Partners.vue?vue&type=script&lang=js"

import "./Partners.vue?vue&type=style&index=0&id=1f7f7a77&lang=css"
script.render = render

export default script